import type { CreateUIAnalyticsEvent } from '@atlaskit/analytics-next';

import { ExperienceActionMeasures } from '@confluence/action-measures';
import { EDIT_ROUTE_CHANGE_TO_TTI_ACTION } from '@confluence/browser-metrics';

const EDITOR_STARTED_MAX_MS = 15000;

type PageAnalyticsOptions = {
	isCreate: boolean | null | undefined;
};

export const sendEditorStartedPageEvent = (
	createAnalyticsEvent: CreateUIAnalyticsEvent,
	analytics: PageAnalyticsOptions,
) => {
	const { isCreate } = analytics;

	const measures = ExperienceActionMeasures.getMeasures();
	if (!measures.hasOwnProperty(EDIT_ROUTE_CHANGE_TO_TTI_ACTION)) {
		return;
	}

	const timeToInitializeEditor = measures[EDIT_ROUTE_CHANGE_TO_TTI_ACTION].duration;
	// Don't send event if editor took longer than 15 seconds to intialize or if page is being created
	if (timeToInitializeEditor > EDITOR_STARTED_MAX_MS || isCreate) return;

	createAnalyticsEvent({
		type: 'sendTrackEvent',
		data: {
			action: 'editorStarted',
			actionSubject: 'performanceTrigger',
			source: 'editPageScreen',
			attributes: {
				timeToInitializeEditor,
			},
		},
	}).fire();
};
